export const chartColumns = [
  {
    field: 'cargoType',
    title: '货物类型',
    width: '120',
    // editRender: {
    //   name: 'select',
    //   type: 'default'
    // },
    //fixme
  },
  {
    field: 'cargoCategory',
    title: '货物品类',
    width: '150',
    // editRender: { name: 'select', type: 'default' },
  },
  {
    field: 'cargoSpecificationsModel',
    title: '货物规格编码',
    width: '140',
    editRender: {
      name: 'input',
      attrs: { type: 'number' },
    },
  },
  {
    field: 'weight',
    title: '重量/数量',
    width: '140',
    editRender: {
      name: 'input',
      attrs: { type: 'number' },
    },
  },
  // {
  //   field: 'weightUnitName',
  //   title: '单位',
  //   width: '140',
  //   editRender: {
  //     name: 'input',
  //   },
  //   //fixme
  // },
  {
    field: 'weightUnit',
    title: '单位',
    width: '140',
    editRender: {
      name: 'input',
    },
    //fixme
  },
  {
    field: 'remarks',
    title: '备注',
    width: '140',
    editRender: {
      name: 'input',
    },
  },
];
